//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setOwnKey } from '@/tools'
import { mapGetters } from 'vuex'
import NumberInputSpinner from '@/components/vue-number-input-spinner/src/components/NumberInputSpinner.vue'

const INPUT_SIZE = [
  { text: '小', value: 'small' },
  { text: '中', value: 'default' },
  { text: '大', value: 'lager' },
]
export default {
  props: {
    question: {
      type: Object,
      default: {
        v_ownId: setOwnKey(),
        v_active: false,
        v_label: '填空题',
        type: 'blank',
        displayIndex: true,
        title: '请填写本项内容',
        required: true,
        size: 'small',
        rule: 'ignore',
        minLength: null,
        maxLength: null,
        uploadArrow: true,
        uploadArrowRequired: false,
        logic: {
          blocks: {
            typeBlock: 'all',
            list: [],
          },
        },
      },
    },
  },
  computed: {
    ...mapGetters(['rules']),
  },
  components: {
    NumberInputSpinner,
  },
  filters: {
    size(value) {
      let obj = { small: '小', default: '中', lager: '大' }
      return value ? obj[value] : value
    },
  },
  methods: {
    minMaxBlur(type) {
      let min = this.question.minLength
      let max = this.question.maxLength
      if (min > max) {
        this.question.maxLength = min
      }
    },
    scoreSettings() {
      new this.$Picker({
        data: [INPUT_SIZE],
        value: this.question.size,
        onOk: (values, text, selectedIndex) => {
          this.question.size = values[0]
        },
      })
    },
    // 内容限制显示
    filterRules(value) {
      let rules = this.rules
      let obj = {}
      rules.forEach((element) => {
        obj[element.value] = element.label
      })
      return value ? obj[value] : ''
    },
    //内容限制选择
    ruleSetting() {
      new this.$Picker({
        data: [this.rules],
        value: this.question.rule,
        dataText: 'label',
        onOk: (values, text, selectedIndex) => {
          let rule = this.question.rule
          if (rule != values[0]) {
            this.question.minLength = null
            this.question.maxLength = null
          }
          this.question.rule = values[0]
        },
      })
    },
  },
}
